// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"d0e2d96a","51":"dc6358c0","244":"03aea76e","759":"b5de1622","767":"241c4478"}[chunkId] + ".chunk.js";
};